<template>
  <div class="container questionnaire-spacing">
    <div class="columns">
      <div class="column questionnaire-section-header">
        <div class="title is-2 has-text-weight-bold">Variable E</div>
        <p style="margin-bottom: 5px;">
          <b>Variable E</b> is the result of a jurisdictional analysis of legal rules and practices, other than those covered by variables A and B, which indicate anticipated compliance with CTC, including those relating to aircraft repossession, enforcement of contractually agreed remedies and dispute resolution provisions, and strict application of commercial laws newly introduced into that legal system.
        </p>
        <p>
          To assist AWG in its assessment of how courts and authorities are likely to fill in actual or perceived gaps in CTC, and, more generally interpret CTC in the enforcement context, please advise on the following. <b>Please do so without reference to effects of CTC.</b> Base your analysis instead on long standing precedent and practice (as CTC effects are addressed under variable B).
        </p>
      </div>
    </div>
    <br />
    <div v-if="$store.getters['isAdmin']">
      <div class="title is-3">Admin Notes</div>
      <editor apiKey="0qgi7f55b2ue7vvn7vvi7w9zim05110j4aznns846hbq588x"
              v-model="adminComment"
              :disabled="$store.getters.currentQuestionnaire.Status == 'Closed'"
              :init="{
                    menubar: false,
                    plugins: [
                    'autoresize',
                    'wordcount'
                    ],
                    toolbar:
                    'formatselect | bold italic underline | \
                    bullist numlist outdent indent | removeformat | spellchecker',
                    browser_spellcheck: true
       }"></editor>
      <hr />
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
  import Editor from '@tinymce/tinymce-vue'
  export default {
    data() {
      return {
        adminComment: ''
      }
    },
    components: {
      'editor': Editor
    },
    methods: {
      async saveAdminComment(sectionId) {
        await this.$http.post("api/questionnaire/adminComment/save", { questionnaireId: this.$store.getters["currentQuestionnaire"].Id, sectionId: sectionId, comment: this.adminComment });
      },
      async getAdminComment(sectionId) {
        await this.$http.post("api/questionnaire/adminComment", { questionnaireId: this.$store.getters["currentQuestionnaire"].Id, sectionId: sectionId })
          .then(resp => {
            if (resp.data.Comment != null) {
              this.adminComment = resp.data.Comment;
            }
            else {
              this.adminComment = "";
            }
          }).catch(err => {
            this.$buefy.notification.open("Could not load Admin Comment.");
          })
      }
    },
    created() {

    }
  }
</script>
